import {useCallback} from 'react'
import {useQuery, useQueryClient} from 'react-query'
import {useNavigate} from 'react-router-dom'
import {useAuth} from '../../auth'
import {getOnboardingProgress, setOnboardingDismissed} from '../core/_requests'

export const ONBOARDING_QUERY_KEY = 'onboarding-progress'

// O checklist só existe depois do primeiro acesso (a tela de boas-vindas vem antes).
export const useOnboardingProgress = () => {
  const {currentUser} = useAuth()

  return useQuery(ONBOARDING_QUERY_KEY, getOnboardingProgress, {
    enabled: !!currentUser?.onboarded,
    refetchOnWindowFocus: true,
    retry: false,
  })
}

// Checklist visível = carregado, não ocultado. Usado também para o RushMind não competir com ele.
export const useIsChecklistVisible = () => {
  const {data} = useOnboardingProgress()
  return !!data && !data.dismissed
}

// "Primeiros passos" nos menus de ajuda: reabre o checklist e leva ao dashboard.
export const useReopenOnboarding = () => {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  return useCallback(async () => {
    await setOnboardingDismissed(false)
    await queryClient.invalidateQueries(ONBOARDING_QUERY_KEY)
    navigate('/dashboard')
  }, [queryClient, navigate])
}
